export default __webpack_public_path__ + "static/media/All-out War.e10631bb.png";